var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-container"},[_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"slider",attrs:{"type":"range"},domProps:{"value":(_vm.localValue)},on:{"__r":function($event){_vm.localValue=$event.target.value}}},'input',_vm.localOptions,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }